import React, { useEffect, useState } from 'react';
import ModalComponent from '../../components/ModalComponent';
import '../../assets/style/Modal.css';
import BasicDetails from '../../components/BasicDetails';
import GridDetails from '../../components/GridDetails';
import ModalHeader from '../../components/ModalHeader';
import {
  assignGridSelector,
  assignGridToEmployee,
  candidateSelector,
  clearReportingManagerData,
  getCandidateDetails,
  getGridList,
  getReportingManagerOfGrid,
} from '../../features/assignGridSlice';
import {
  UserType,
  GridOptionType,
  IAgriGridType,
  LoggedUserType,
  ReportingManagerType,
  AssignGridDataType,
} from '../../utils/Types';
import CenterSpinner from '../../components/CenterSpinner';
import { toast } from 'react-toastify';

import { isAPIFailed, isAPISuccess } from '../../utils/Util';
import { loginSelector } from '../../features/loginSlice';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import {
  checkMatchedGrid,
  findGridDetailsAndPolygonArray,
  getGridOption,
} from '../assign-grid/AssignGridHelper';
import { useLoader } from '../../loader/LoaderProvider';

interface IAssignGridModalProps {
  isOpen: boolean;
  toggle: () => void;
  candidateId?: number | string;
  pincode?: number;
  did?: string;
  assignedgrids?: string;
  selectedUser?: AssignGridDataType | null;
  refreshData?: () => void;
}

const AssignGridModal: React.FunctionComponent<IAssignGridModalProps> = ({
  isOpen,
  toggle,
  candidateId,
  assignedgrids,
  pincode,
  selectedUser,
  refreshData,
}: IAssignGridModalProps) => {
  const dispatch = useAppDispatch();
  const [user, setUser] = useState<UserType>();
  const { showLoader, setShowLoader } = useLoader();
  const [gridOptions, setGridOptions] = useState<any>([]);
  const [iAgriGridData, setIAgriGridData] = useState<IAgriGridType[]>([]);
  const [selectedGridIds, setSelectedGridIds] = useState<GridOptionType[]>([]);
  const [selectedGridsDetails, setSelectedGridsDetails] =
    useState<IAgriGridType[]>();
  const [selectedGridsLatLngArray, setSelectedGridsLatLngArray] =
    useState<any[]>();
  const userDetails: UserType = useAppSelector(candidateSelector).user;
  const loggedUser: LoggedUserType = useAppSelector(loginSelector).user;
  const [selectedGridPincode, setSelectedGridPincode] = useState<any>([]);
  const reportingManagerDetails: ReportingManagerType =
    useAppSelector(assignGridSelector).gridReportingManager;

  const [managerData, setManagerData] = useState({
    reportingManager: '',
    reportingManagerRole: '',
    reportingManagerVillageName: '',
    reportingManagerStateName: '',
  });
  /**
   * Clear map from added polygons
   */

  const toggleModal = () => {
    toggle();
  };

  const findReportingManager = () => {
    if (pincode) {
      dispatch(getReportingManagerOfGrid(pincode));
    }
  };

  const findPospReportingManager = () => {
    if (selectedGridPincode) {
      dispatch(getReportingManagerOfGrid(selectedGridPincode));
    }
  };

  function getUniqueConcatenatedValues(data: any, key: any) {
    const values = new Set();
    data.forEach((item: any) => {
      const fieldValue = item[key];
      if (fieldValue) {
        // Handle comma-separated values like "Hyderabad,Madhapur"
        fieldValue.split(',').forEach((val: any) => values.add(val.trim()));
      }
    });
    return Array.from(values).join(',');
  }

  /**
   * Find grids details and prepare option array to display in select.
   */
  type SNNUType = string | number | null | undefined;

  const findGridsForPincode = (villageId: SNNUType[] = []) => {
    if (pincode) {
      dispatch(
        getGridList({
          pincode: pincode,
          vid: villageId,
          candidateId: candidateId ?? '',
        })
      )
        ?.then(async (fulfilled: any) => {
          const gridResponse = getGridOption(fulfilled);
          setGridOptions(gridResponse.gridOptions);
          setIAgriGridData((prev: any[]) => [
            ...prev,
            ...gridResponse.response,
          ]);
          const updatedData = {
            reportingManager: getUniqueConcatenatedValues(
              fulfilled.payload?.response &&
                Array.isArray(fulfilled.payload?.response)
                ? fulfilled?.payload?.response
                : [],
              'ReportingManagerName'
            ),
            reportingManagerRole: getUniqueConcatenatedValues(
              fulfilled.payload?.response &&
                Array.isArray(fulfilled.payload?.response)
                ? fulfilled?.payload?.response
                : [],
              'ReportingManagerRole'
            ),
            reportingManagerVillageName: '',
            reportingManagerStateName: '',
          };

          setManagerData(updatedData);
          let filteredOptions = await [...gridResponse.gridOptions];
          const updatedIAgriGridData = await [
            ...iAgriGridData,
            ...gridResponse.response,
          ];
          if (assignedgrids?.split(',')?.length) {
            const gridIds = await assignedgrids
              ?.split(',')
              ?.map((num: any) => num.trim());
            filteredOptions = await gridResponse?.gridOptions?.filter(
              (item: any) => !gridIds.includes(item.value)
            );
            setSelectedGridIds(filteredOptions);
          } else {
            setSelectedGridIds(filteredOptions);
          }
          findGridDetailsAndPolygonArray(
            filteredOptions,
            updatedIAgriGridData,
            setSelectedGridsDetails,
            setSelectedGridsLatLngArray
          );
        })
        ?.catch(() => {});
    }
  };
  /**
   * Find selected candidate details on the basis of candidate id
   */
  const findCandidateDetails = () => {
    if (candidateId) {
      setShowLoader(true);
      dispatch(getCandidateDetails(candidateId));
    }
  };
  useEffect(() => {
    if (candidateId === userDetails.candidateid) {
      setUser(userDetails);
      setShowLoader(false);
    } else if (!userDetails.candidateid) {
      setShowLoader(false);
    }
  }, [userDetails]);
  useEffect(() => {
    findCandidateDetails();
  }, [candidateId]);
  useEffect(() => {
    dispatch(clearReportingManagerData());
    setSelectedGridIds([]);
    setSelectedGridsDetails(undefined);
    if (selectedUser?.candidateuniqueid?.substring(0, 2) === 'CD')
      findGridsForPincode();
    // if (selectedUser?.roleid != 6) {
    //   findReportingManager();
    // }
  }, [pincode]);

  // useEffect(() => {
  //   if (selectedUser?.roleid === 6) findPospReportingManager();
  // }, [selectedGridPincode]);

  const onSelectChange = (event: any) => {
    setSelectedGridIds(event);
    findGridDetailsAndPolygonArray(
      event,
      iAgriGridData,
      setSelectedGridsDetails,
      setSelectedGridsLatLngArray
    );
  };
  /**
   * Call API to assign grids to candidate
   * @returns
   */
  const assignGrid = () => {
    const matchedGrid = checkMatchedGrid(selectedGridIds, assignedgrids);
    if (matchedGrid.isMatch) {
      return;
    }

    setShowLoader(true);
    dispatch(
      assignGridToEmployee({
        candidateId: user?.candidateid,
        gridIds: matchedGrid?.grids?.map((grid) => grid.gridId),
        assignedBy: loggedUser.candidateId,
      })
    )
      ?.then((fulfilled: any) => {
        setShowLoader(false);
        if (isAPIFailed(fulfilled?.payload)) {
          toast.error(fulfilled?.payload?.responseInformation.responseMessage);
        } else if (isAPISuccess(fulfilled?.payload)) {
          toggleModal();
          toast.success(
            fulfilled?.payload?.responseInformation.responseMessage
          );
        }
      })
      ?.catch(() => {
        setShowLoader(false);
        toast.error('Grid assignment failed!');
      });
  };

  return (
    <ModalComponent
      isOpen={isOpen}
      toggle={toggleModal}
      className="modalWrapper"
      backdrop="static"
    >
      <div className="bg-white p-2 rounded border">
        <ModalHeader photoUrl={user?.photo} toggle={toggleModal} />
        <BasicDetails
          user={user}
          assignedgrids={assignedgrids}
          refreshData={toggleModal}
          setShowLoader={setShowLoader}
        />
        <GridDetails
          options={gridOptions}
          selectedGridIds={selectedGridIds}
          selectedGridsDetails={selectedGridsDetails}
          polygonPositionsArray={selectedGridsLatLngArray}
          assignedgrids={assignedgrids}
          onSelectChange={onSelectChange}
          reportingManagerDetails={managerData}
          selectedUser={selectedUser}
          onGridAction={() => {
            assignGrid();
          }}
          findGridsForPincode={findGridsForPincode}
          setSelectedGridPincode={(data: any) => setSelectedGridPincode(data)}
        />
        <CenterSpinner showLoader={showLoader} />
      </div>
    </ModalComponent>
  );
};

export default AssignGridModal;
